import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { onboardingSelector } from '../../../reducers/onboarding';
import { apiRequest } from '../../../APIClient';

// on mount, fetch scanner section once if it hasn't been fetched before
export const useFetchScannerSection = () => {
  const hasFetched = useSelector(onboardingSelector.hasFetchedScannerSection);

  const dispatch = useDispatch();

  React.useEffect(() => {
    if (!hasFetched) {
      dispatch(apiRequest.getOBScanners());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);
};
